// Charts are vector primitives in every format, including editable PowerPoint shapes.
const advisorPresentationChartsApi = (() => {
  const draw = (block: any, a: any, x: number, y: number, width: number, height: number) => {
    const colors = [a.colors.purple, a.colors.green, a.colors.red];
    const format = (v: number) => new Intl.NumberFormat(a.locale || undefined, { notation: 'compact', maximumFractionDigits: 1 }).format(v);
    let categories = [...(block.categories || [])];
    const series = block.series || [];
    let waterfall: any[] = [];
    if (block.variant === 'waterfall') {
      let running = Number(block.opening) || 0;
      waterfall = [{ from: 0, to: running, value: running, color: a.colors.purple }];
      (series[0]?.values || []).forEach((raw: any) => {
        const value = Number(raw) || 0, from = running;
        running += value;
        waterfall.push({ from, to: running, value, color: value < 0 ? a.colors.red : a.colors.green });
      });
      waterfall.push({ from: 0, to: Number(block.closing) || 0, value: Number(block.closing) || 0, color: a.colors.purple });
      categories = [block.openingLabel, ...categories, block.closingLabel];
    }
    const values = waterfall.length ? waterfall.flatMap((b) => [b.from, b.to]) : series.flatMap((s: any) => s.values.map(Number));
    const maximum = Math.max(1, ...values, Number(block.marker?.value) || 0);
    const minimum = Math.min(0, ...values);
    const range = maximum - minimum;
    const left = x + 80, right = x + width - 8;
    const top = y + (block.compact ? block.title ? 34 : 10 : 52), bottom = y + height - (block.compact ? 44 : 70);
    const at = (v: number) => bottom - (v - minimum) / range * (bottom - top);
    const count = Math.max(1, categories.length), step = (right - left) / count;
    if (block.title) a.text(a.page, block.title, x, y, width, 19, { bold: true });
    for (let i = 0; i < 4; i++) {
      const value = minimum + range * i / 3;
      const yy = at(value);
      a.line(a.page, left, yy, right - left, 0);
      a.text(a.page, format(value), x, yy - 9, 68, 13, { align: 'right', color: a.colors.muted });
    }
    a.line(a.page, left, at(0), right - left, 0, a.colors.muted);
    if (waterfall.length) waterfall.forEach((bar, i) => {
      const barW = Math.min(50, step * .55), xx = left + step * (i + .5);
      a.rect(a.page, xx - barW / 2, Math.min(at(bar.from), at(bar.to)), barW, Math.max(1, Math.abs(at(bar.from) - at(bar.to))), bar.color);
      if (i < count - 1) a.line(a.page, xx + barW / 2, at(bar.to), step - barW, 0, a.colors.muted);
    });
    else series.forEach((s: any, seriesIndex: number) => {
      const points = s.values.map((raw: any, i: number) => [left + step * (i + .5), at(Number(raw) || 0)]);
      if (block.variant === 'line' && points.length > 1) a.page.nodes.push({ kind: 'path', x: 0, y: 0, points, color: colors[seriesIndex % colors.length] });
      else s.values.forEach((raw: any, i: number) => {
        const v = Number(raw) || 0, bw = Math.min(48, step * .7 / Math.max(1, series.length));
        const xx = left + step * (i + .5) + (seriesIndex - (series.length - 1) / 2) * bw;
        a.rect(a.page, xx - bw / 2, Math.min(at(v), at(0)), Math.max(1, bw - 2), Math.max(1, Math.abs(at(v) - at(0))),
          block.colorBySign ? v < 0 ? a.colors.red : a.colors.green : colors[seriesIndex % colors.length]);
      });
    });
    const abbreviated = block.compact && categories.length > 6;
    const axisLabels = abbreviated ? categories.map((label: string) => String(label).slice(0, 3)) : categories;
    const numbered = block.numberedAxis || axisLabels.some((label: string) => a.wrap(label, step - 3, 13).length > 2);
    axisLabels.forEach((label: string, i: number) => a.text(a.page, numbered ? String(i + 1) : label, left + i * step, bottom + 12, step - 3, 13, { align: 'center', color: a.colors.muted }));
    if (numbered && !block.numberedAxis) block.axisKey = categories.map((label: string, i: number) => `${i + 1}. ${label}`);
    if (block.marker) {
      const markerY = at(Number(block.marker.value) || 0);
      a.line(a.page, left, markerY, right - left, 0, a.colors.amber);
      a.text(a.page, `${block.marker.label}: ${format(block.marker.value)}`, x, y + height - 12, width, 14, { color: a.colors.amber });
    } else if (series.length > 1) {
      series.forEach((s: any, i: number) => a.text(a.page, s.label, x + i * width / series.length, y + height - 12, width / series.length - 12, 14, { color: colors[i % colors.length] }));
    }
  };
  return { draw };
})();
Object.assign(window, { PlummeAdvisorPresentationCharts: advisorPresentationChartsApi });
